// ===========================================
// Environment Configuration
// ===========================================
// Auto-detect environment based on hostname
const ENV = window.location.hostname === "localhost" ||
            window.location.hostname === "127.0.0.1"
            ? "local" : "prod";

const ENV_CONFIG = {
  local: {
    apiBaseURL: "http://localhost:8001",
    feedbackURL: "http://localhost:3000",
  },
  prod: {
    apiBaseURL: "https://survey.topcx.ai",
    feedbackURL: "https://feedback.topcx.ai",
  }
};

const apiBaseURLAdmin = ENV_CONFIG[ENV].apiBaseURL;
const feedbackBaseURL = ENV_CONFIG[ENV].feedbackURL;

// ------------- Authentication ----------------
const auth = `${apiBaseURLAdmin}/auth`;

// ------------- Subscription Management ----------------
const subscription = `${apiBaseURLAdmin}/subscription`;
//ingestion status
// const paymentStatusLive = `${apiBaseURLAdmin}/payment_status/polling`;
const paymentStatusLive = `${apiBaseURLAdmin}/new_payment_status/polling`;

// ------------- Notification ----------------

// ------------- ThirdParty Cookies ----------------
const tpCookies = `https://tpcookie.cxchatgpt.ai/`;

// ------------- Contact ----------------
const contact = `${apiBaseURLAdmin}/survey`;

// ------------- Feature Management ----------------
//ingestion
const startIngestion = `${apiBaseURLAdmin}/settings/start_ingestion`;
//settings
const viewSettings = `${apiBaseURLAdmin}/settings/view_settings`;
const updateSettings = `${apiBaseURLAdmin}/settings/update_settings`;
const infoSettings = `${apiBaseURLAdmin}/settings/view_dashboard_info`;

// ------------- Role Management ----------------
const roleManagement = `${apiBaseURLAdmin}/RoleMgmt`;
const roleManagementNew = `${apiBaseURLAdmin}/manage`;

// ------------- Analytics Dashboard ----------------
const analytics = `${apiBaseURLAdmin}/dashboard`;

// ------------- X Survey ----------------
const xSurvey = `${apiBaseURLAdmin}/survey`;
// ------------- QA Dashboard ----------------/

// ------------- Company Auth ----------------
const company = `${apiBaseURLAdmin}/company`;

export const ApiConfig = {
  // ------------- Authentication ----------------
  // login: `${auth}/login`,
  login: `${auth}/newlogin`,
  xSurveyAuthCheck: `${auth}/update_checkup`,

  // ------------- Company Registration ----------------
  signup: `${company}/register-zendesk`,
  lookupEmail: `${company}/lookup-email`,
  getConfig: `${company}/config`,

  // ------------- Third Party Cookies ----------------

  tpCookieCheck: `${tpCookies}`,

  // ------------- Subscription Management ----------------

  // features: `${subscription}/features`,
  features: `${subscription}/catalog`,
  // pricingLink: `${subscription}/create-checkout-session`,
  pricingLink: `${subscription}/new-create-checkout-session`,
  customerPortal: `${subscription}/create-customer-portal-session`,
  // startTrail: `${subscription}/start_trial`,
  startTrail: `${subscription}/newstart_trial`,
  // orgStatus: `${subscription}/fetch_org_plan_details`,
  orgStatus: `${subscription}/new_fetch_org_plan_details`,
  paymentStatusLive: `${paymentStatusLive}`,

  // ------------- Help/Contact ----------------
  contactUs: `${contact}/contact_us`,
  helpForm: `${contact}/help`,

  // ------------- Feature Management ----------------

  // TopX

  // XSurvey
  xSurveyDetails: `${viewSettings}/xsurvey`,
  xSurveyIngestion: `${startIngestion}/xsurvey`,
  xSurveyUpdateSettings: `${updateSettings}/xsurvey`,
  XSurveyOverallView: `${xSurvey}/overall_view`,
  XSurveyGraph: `${xSurvey}/survey_graph`,
  XSurveyFilter: `${xSurvey}/get_survey_template_list`,
  xSurveyLicensesInfo: `${infoSettings}/survey`,

  // XAnalytics

  // XQA

  // Stop Live Status (TopX, BotX, XAnalytics, XQA)
  stopLiveStatus: `${apiBaseURLAdmin}/stop-all-sse`,

  // ------------- Role Management ----------------

  // Agents
  // rmGetAgents: `${roleManagement}/GetAgents`,
  rmGetAgents: `${roleManagementNew}/users`,
  rmResetAgents: `${roleManagement}/ResetAgents`,
  // rmFetchNewAgents: `${roleManagement}/FetchNewAgents`,
  rmFetchNewAgents: `${roleManagementNew}/fetch_agents`,
  rmUpdateAgentStatus: `${roleManagement}/UpdateAgentStatus`,

  // Teams
  rmCreateTeam: `${roleManagement}/CreateTeam`,
  rmAssignTeam: `${roleManagement}/AssignTeam`,
  rmDeleteTeam: `${roleManagement}/DeleteTeam`,
  rmUpdateTeam: `${roleManagement}/UpdateTeam`,
  rmAssignTeamLead: `${roleManagement}/AssignTeamLead`,

  // Licenses/Roles
  rmManageLicensesRoles: `${roleManagementNew}/users`,
  // ------------- Analytics ----------------
  analyticsFilter: `${analytics}/filter_data`,
  analyticsGraph: `${analytics}/card_data/graph/`,
  analyticsAgentList: `${analytics}/card_data/agent_list/`,
  analyticsTopBarData: `${analytics}/top_bar_data/`,
  analyticsTicketData: `${analytics}/ticket_data/`,
  analyticsTotalValue: `${analytics}/total_kpi_value/`,
  analyticsTooltips: `${analytics}/tooltips/xanalytics`,
};
